'use client'
import { FC } from 'react'
import { VStack } from '@chakra-ui/react'
import { GrandSection, GrandText } from 'ui'
import CustomSummaryBoxesWidgetItemComponent from './CustomSummaryBoxesWidgetItem'
import { summaryBoxesCn as cn } from './constants'
import { SummaryBoxesWidgetHandlerProps, WIDGET_GROUP_CN } from 'storefront-modules/widgets'

export const CustomSummaryBoxesWidget: FC<SummaryBoxesWidgetHandlerProps> = ({
  widgetId,
  widget: {
    widget: { title, description, items, itemsAspectRatio }
  },
  ...props
}) => {
  return (
    <GrandSection
      className={cn(WIDGET_GROUP_CN.SECTION)}
      contentContainerProps={{
        className: cn(WIDGET_GROUP_CN.SECTION_CONTAINER)
      }}
      sectionId={widgetId}
      title={title}
      titleProps={{
        className: cn(WIDGET_GROUP_CN.SECTION_TITLE),
        containerProps: {
          className: cn(WIDGET_GROUP_CN.SECTION_TITLE_CONTAINER)
        },
        decorationProps: {
          className: cn(WIDGET_GROUP_CN.SECTION_TITLE_DECORATION)
        }
      }}
      {...props}
    >
      {description ? (
        <GrandText className={cn(WIDGET_GROUP_CN.SECTION_DESC)}>{description}</GrandText>
      ) : null}

      <VStack className={cn(WIDGET_GROUP_CN.WRAPPER)} spacing={10}>
        {items.map((item) => (
          <CustomSummaryBoxesWidgetItemComponent
            aspectRatio={itemsAspectRatio}
            key={item.id}
            type={item.isReversed ? 'right' : 'left'}
            {...{ item }}
          />
        ))}
      </VStack>
    </GrandSection>
  )
}
